// extracted by mini-css-extract-plugin
export var statItem = "_ic-1";
export var statsRow = "_ic-0";